import { IconCheck } from "@tabler/icons-react";
import styles from "./stepBar.module.css";

const STEP_NAMES = [
  "Company Logo",
  "Company Type",
  "Company Information",
  "Additional Information",
];

const StepBar = ({ currentStep, completed }) => {
  const isCompleted = completed;
  const mobilePct = (Math.min(currentStep, 4) / 4) * 100;
  const mobileName = isCompleted
    ? "Complete"
    : STEP_NAMES[Math.min(currentStep, 4) - 1];

  return (
    <div className={styles.stickyWrap} id="stepsStickyWrap">
      <div className={styles.shell}>
        {/* Desktop step circles */}
        <div
          className={`${styles.steps} ${isCompleted ? styles.stepsCompleted : ""}`}
        >
          {STEP_NAMES?.map((name, i) => {
            const stepNum = i + 1;
            const isDone = isCompleted || stepNum < currentStep;
            const isActive = !isCompleted && stepNum === currentStep;
            const cls = [
              styles.step,
              isActive ? styles.stepActive : "",
              isDone ? styles.stepDone : "",
            ]
              .filter(Boolean)
              .join(" ");

            return (
              <div key={stepNum} className={cls}>
                <div className={styles.stepCircle}>
                  {isDone ? (
                    <IconCheck size={14} />
                  ) : (
                    stepNum
                  )}
                </div>
                <div className={styles.stepLabel}>
                  {name.split(" ").map((word, j) => (
                    <span key={j}>
                      {word}
                      <br />
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Mobile indicator */}
        <div className={styles.msi}>
          <div className={styles.msiRow}>
            <span className={styles.msiCount}>
              Step <span>{Math.min(currentStep, 4)}</span> of 4
            </span>
            <span className={styles.msiName}>{mobileName}</span>
          </div>
          <div className={styles.msiBar}>
            <div
              className={styles.msiFill}
              style={{ width: `${mobilePct}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepBar;
